module.exports = __webpack_public_path__ + "media/images/crown-2-cba3250848187d5213a83628162eedd5.svg";